/** @module MomentHelper */

/**
 * Takes a date in format 'M/YYYY' and returns a moment consumable date array [YYYY, M-1].
 * Javascript months are zero based, this is why we decrement the month
 *
 * @param {String} date - 'M/YYYY' representation of a date
 *
 * @return {Array.<Integer>} - [YYYY, M-1]
 *
 * @example
 *
 * input = '5/2018'
 *
 * output = [2018, 4]
 *
 */
export function formatForMomentMonthFirst(date) {
  const pieces = date.split('/').map(piece => parseInt(piece))
  pieces[0]--
  return pieces.reverse()
}


/**
 * Takes a date in format 'YYYY/M' and returns a moment consumable date array [YYYY, M-1].
 * Javascript months are zero based, this is why we decrement the month
 *
 * @param {String} date - 'YYYY/M' representation of a date
 *
 * @return {Array.<Integer>} - [YYYY, M-1]
 *
 * @example
 *
 * input = '2018/5'
 *
 * output = [2018, 4]
 *
 */
export function formatForMomentYearFirst(date) {
  const pieces = date.split('/').map(piece => parseInt(piece))
  pieces[1]--
  return pieces
}

